/*
* class AppTools
*/

var AppTools = function() {

    /*
    * Env variables
    */
    var body        = document.body,
        bezier      = 'cubic-bezier(.58,.01,.19,1)',
        scrollList  = [],
        chartList   = [],
        listmarkers = [],
        listmaps    = [],
        windowheight,
        windowWidth,
        flagscreen,
        scrolldirection = null,
        pa = {'templateurl':'/dist'}

    /*
    * Sizes grille (Inférieur à | Ex: ml = < 1600)
    */
    var sizeml = 1600,
        sizems = 1280,
        sizem  = 1024,
        sizesm = 768,
        sizes  = 426;

    /*
    * useragents
    */
    var deviceAgent = navigator.userAgent.toLowerCase(),
        agentID     = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        screentype;

    var ie          = /MSIE \d|Trident.*rv:/.test(navigator.userAgent);

    /**
     * Carousel
     */

    var initGlide = function() {

        var slides = document.querySelectorAll('.glide');

        for (var i = 0; i < slides.length; i++) {
            
            var slide = slides[i];
            
            var glide = new Glide('#'+slide.id, {
                type:'carousel',
                autoplay: 3500,
                startAt: 0,
                gap: 30,
                perView:3,
                breakpoints: {
                    600: {
                        perView: 2
                    }
                }
            });
    
            // // input.addEventListener('input', function (event) {
            // // glide.update({
            // //     startAt: event.target.value
            // // })
            // // })
    
            glide.mount();
        }

    }

    /*
    * Front
    */


    /*
    * Tracking/event analytics
    */
    var track = function(category,label)
    {
        if ('ga' in window) {
            var tracker = ga.getAll()[0];
            if(tracker)
                tracker.send('event', category, label);
        }
    }

    /*
    * Check si touchevent
    */
    var touchEvents = function() {
        
        try {

            document.createEvent("TouchEvent");  
            return true;  

        } catch (e) {  
            
            return false;  
        }  
    }

    /*
    * Check si nav "mobile" sous entendu interface opti pour les select
    */
    var mobileBrowser = function() {
        
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        
        return check;
    }

    /*
    * Class compat css navigateurs
    */
    var cssCompatibility = function() {

        // flexbox
        var c      = " ", prefixFlex = 'flex -webkit-flex -ms-flexbox -moz-box -webkit-box'.split(' '), 
            elem   = document.createElement('b'), 
            mStyle = elem.style;

        try{
            for(var i = 0, len = prefixFlex.length; i < len; i++)
                c += ( (mStyle.display = prefixFlex[i]) && mStyle.display != prefixFlex[i] ) ? 'no-flex' :  'flex', (i = len);

        }catch(e){ 
            c += "no-flex";
        }

        document.documentElement.className =  c + 'box';
    }

    var isVisible = function(el) {

        let t = el.y + window.pageYOffset;
        let b = t + el.offsetHeight;
        let h = el.offsetHeight;

        // console.log(window.pageYOffset+window.innerHeight, t,h)
        if( (window.pageYOffset+window.innerHeight) > (t) )
            return true;

        return false;
    }

    /*
    * lazyLoad images
    */
    var lazyloadimg = function()
    {
        let images  = document.querySelectorAll('img[data-src]');
        
        for (var i = 0; i < images.length; i++){
            let img = images[i];

            if(!img.classList.contains('loaded')){

                if(isVisible(img)){

                    img.setAttribute('src', img.getAttribute('data-src'));
                    img.onload = function() {
                        // img.removeAttribute('data-src');
                        if( img.getAttribute('data-adaptative') )
                            adaptativeimg(img)
                        
                        let parent = img.parentElement;

                        if(parent.classList.contains('back_image'))
                            parent.classList.add('loaded');

                        img.classList.add('loaded');
                    };
                    // console.log(images[i], isVisible(img))
                }
            }
        }
    }

    var lazyBackground = function()
    {
        let backs = document.querySelectorAll('[data-lazy-background]');
        for (var i = 0; i < backs.length; i++){
            let back = backs[i]; 

            if(!back.classList.contains('backloaded')){
                back.style.backgroundImage = 'url('+back.getAttribute('data-lazy-background')+')';
                let img = new Image();
                img.onload = function() {
                    back.classList.add('backloaded');
                };
                img.src = back.getAttribute('data-lazy-background');
            }
        }
    }
    
    /*
    * Auto adapt images
    */
    var adaptativeimg = function(el)
    { 
        let images;

        if(el)
            images = [el];
        else
            images = document.querySelectorAll('img[data-adaptative]');
        
        for (var i = 0; i < images.length; i++) {

            
            let image     = images[i];
            let container = image.parentElement;
            let data      = image.dataset;

            // si image plus haute que son conteneur
            if( image.clientHeight > container.clientHeight && image.clientWidth === container.clientWidth ){

                let diff = ( image.clientHeight - container.clientHeight ) / 2;                
                image.style.transform = 'translateX(0px) translateY(-'+diff+'px)';
                image.style.maxWidth  = '100%';
                // console.log('image plus haute à centrer verticalement');
            }
            else if( image.clientHeight > container.clientHeight && image.clientWidth > container.clientWidth ){

                image.style.maxWidth  = '100%';
                image.style.height    = 'auto';

                let diff = ( image.clientHeight - container.clientHeight ) / 2;                
                image.style.transform = 'translateX(0px) translateY(-'+diff+'px)';
                // console.log('image plus grande que conteneur');

                if( image.clientHeight < container.clientHeight ){
                    
                    image.style.height    = '100%';
                    image.style.transform = 'translateY(0px)';

                    image.style.width    = 'auto';
                    image.style.maxWidth = 'none';
                    
                    let diff = ( image.clientWidth - container.clientWidth ) / 2;                
                    image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
                    // console.log('(second traitement) - image moins haute que le conteneur');
                }
            }
            else if( image.clientHeight < container.clientHeight && data.adaptative === 'cover' ){
                // console.log(image.clientWidth)
                image.style.height    = '100%';
                image.style.transform = 'translateY(0px)';

                image.style.width    = 'auto';
                image.style.maxWidth = 'none';

                let diff = ( image.clientWidth - container.clientWidth ) / 2;                
                image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
                // console.log('image moins haute que le conteneur');
                // console.log(image.clientWidth,diff)

                if( image.clientWidth < container.clientWidth ){
                    
                    image.style.height    = 'auto';

                    image.style.width    = '100%';
                    image.style.maxWidth = 'none';
                    
                    let diff = ( image.clientHeight - container.clientHeight ) / 2;                
                    image.style.transform = 'translateY(-'+diff+'px) translateX(0px)';
                    // console.log('(second traitement) - image moins large que le conteneur');
                }

            }
            else if( image.clientWidth < container.clientWidth && data.adaptative === 'cover' ){
                
                image.style.height    = 'auto';

                image.style.width    = '100%';
                image.style.maxWidth = 'none';
                
                let diff = ( image.clientHeight - container.clientHeight ) / 2;                
                image.style.transform = 'translateY(-'+diff+'px) translateY(0px)';
                // console.log('image moins large que le conteneur');
            }
            else if( image.clientWidth > image.clientHeight ){

                image.style.height    = '100%';
                image.style.transform = 'translateY(0px)';

                image.style.width    = 'auto';
                image.style.maxWidth = 'none';

                let diff = ( image.clientWidth - container.clientWidth ) / 2;                
                image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
                // console.log('image large');
            }
            else if( image.clientWidth === image.clientHeight ){

                // console.log('image carré');

                if( container.clientWidth > container.clientHeight ) {
                    // console.log('conteneur paysage');
                    image.style.width     = '100%';
                    image.style.transform = 'translateY(0px)';
                    image.style.height    = 'auto';
                    image.style.maxWidth  = 'none';
                    image.style.maxHeight = 'none';
                    let diff = ( image.clientHeight - container.clientHeight ) / 2;
                    image.style.transform = 'translateY(-'+diff+'px) translateX(0px)';
                }else{
                    // console.log('conteneur portrait');
                    image.style.height    = '100%';
                    image.style.transform = 'translateY(0px)';
                    image.style.width    = 'auto';
                    image.style.maxWidth = 'none';
                    let diff = ( image.clientWidth - container.clientWidth ) / 2;
                    image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
                }
            }
            else{
                image.style.transform = 'translateY(0px) translateX(0px)';
            }

            image.classList.add('traited');
            // items[i].style.height = h+'px';
        }
    }

    /**
     * Run functions after scrolling has stopped
     * Fork de scrollStop.js | (c) 2017 Chris Ferdinandi | MIT License
     * http://github.com/cferdinandi/scrollStop
     * @param  {Function} callback The function to run after scrolling
     */
    var scrollStop = function ( callback ) {

        // Make sure a valid callback was provided
        if ( !callback || Object.prototype.toString.call( callback ) !== '[object Function]' ) return;

        // Setup scrolling variable
        let isScrolling;
        let noscroll;

        // Listen for scroll events
        window.addEventListener('scroll', function ( event ) {

            // Clear our timeout throughout the scroll
            window.clearTimeout( isScrolling );
            window.clearTimeout( noscroll );

            // Set a timeout to run after scrolling ends
            isScrolling = setTimeout(function() {

                // Run the callback
                callback();

            }, 66);

        }, false);

        // if no scroll append fallback
        noscroll = setTimeout(function(){
            callback();
        }, 500);
    }
    
    /*
    * Actions hook au scroll
    */
    var scrollAction = function () {
        
        let scrollPos = 0;
        window.addEventListener('scroll', function(){

            let scrolltop = (window.scrollY) ? window.scrollY: window.pageYOffset;

            if ( scrolltop < scrollPos )
                scrolldirection = 'up';
            else
                scrolldirection = 'down';
            
            scrollPos = scrolltop;
            // (document.body.getBoundingClientRect()).top;

            if(scrolltop < 0)
                document.body.classList.add('negative-scroll')
            else
                document.body.classList.remove('negative-scroll')
        });

        let headbar = document.getElementById('fixed_head');
        let links   = document.querySelectorAll('a[href^="#"]');

        for (let index = 0; index < links.length; index++) {
            
            let anchor = links[index];
            anchor.addEventListener('click', function (event) {
                event.preventDefault();
                
                let target    = document.querySelector(anchor.getAttribute('href'));
                let bodyrect  = document.body.getBoundingClientRect();
                let targetpos = target.getBoundingClientRect();
                
                window.scroll({
                    top: targetpos.top - bodyrect.top - headbar.offsetHeight - 15, 
                    behavior: 'smooth' 
                });
            });
        }
    }

    return {

        /*
        * Main class initializer
        */
        init: function() {
            AppTools.initComponents();
        },

        /*
        * Initializes components
        */
        initComponents: function() {
            
            // initresize()  
            initGlide()
            scrollAction()
            // smoothscroll()
            cssCompatibility()
            // adaptativeimg()

            window.addEventListener('resize', function() {
                // initresize()
                // refreshScrolls()
                // adaptativeimg()
            })

            if(ie){
                document.body.classList.add('ie')
                document.write('<script src="'+pa.templateurl+'/js/svg4everybody.min.js" type="text/javascript"><\/script>');
                
                // var cb = function() {
                //     var l  = document.createElement('link'); l.rel = 'stylesheet';
                //     l.href = '/css/fixie.css';
                //     var h  = document.getElementsByTagName('head')[0]; h.appendChild(l, h);
                // };
                // var raf = requestAnimationFrame || mozRequestAnimationFrame ||
                //     webkitRequestAnimationFrame || msRequestAnimationFrame;
                // if (raf) raf(cb);
                // else window.addEventListener('load', cb);
            }
        },

        _doRequest: function(form) {
            return _doRequest(form);
        },

        getScrollDirection: function() {
            return scrolldirection;
        },

        scrollStop: function(callback) {
            scrollStop(callback);
        },

        isbot: function() {

            return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
        },

        isie: function() {
            return ie;
        },

        getTouchEvent: function() {
            return touchEvents();
        },

        getBody: function() {
            return $body;
        },

        getUserAgent: function() {
            return agentID;
        },

        getScreenType: function() {
            return screentype;
        },

        initLazyBackground: function() {
            lazyBackground();
        },

        initLazyloadimg: function() {
            lazyloadimg();
        },

        initCarousels: function() {
            carousels();
        },
        
        initCarouselsResp: function() {
            controlRespSliders();
        },

        initAdaptativeImage: function() {
            adaptativeimg();
        },

        initMap: function() {
            initMap();
        },

        initTooltips: function() {
            tooltip();
        },

        initScrollers: function() {
            scrollWrap();
        },

        refreshScrolls: function() {
            refreshScrolls();
        },

        storeLocal: function(id,val) {
            return storeLocal(id,val);
        },

        getLocal: function(id,key) {
            return getLocal(id,key);
        },

        removeLocal: function(id,key) {
            return removeLocal(id,key);
        },

        track:function(cat,label) {
            track(cat,label);
        }
    };

}();

// (function() {
//     AppTools.init();
// })();